// 在http.js中引入axios
import axios from 'axios'; // 引入axios
import QS from 'qs'; //
import { Toast } from 'mint-ui';

if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = '/api';}
else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '/api';
}
else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://api.songshuiqishi.com';
  // axios.defaults.baseURL = 'https://devapi.songshuiqishi.com';   //测试服接口
}

axios.defaults.timeout = 30000;

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 先导入vuex,因为我们要使用到里面的状态对象
// vuex的路径根据自己的路径去写

// 请求拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
})



// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.data.code == 0) {
            return Promise.resolve(response);
        } else {
            Toast({
                message: response.data.msg,
                duration: 2000,
                iconClass: 'icon el-icon-error'
            });
            return Promise.reject(response);
        }
    },
    error => {
        const config = error.config;
        // 判断请求异常信息中是否含有超时timeout字符串
        Toast({
            message: '网络链接失败，请稍后再试!',
            duration: 2000,
            iconClass: 'icon el-icon-error'
        });
        return Promise.reject(error)
    }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)
    })
});}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        //  axios.post(url, QS.stringify(params))
         axios.post(url, params)
        .then(res => {
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}




// WEBPACK FOOTER //
// ./src/request/http.js